import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import qs from 'qs';
//
import { Location } from 'history';
import routes from '../../router/routes';
import { fetchAccessTokenResponse, fetchUserAuthorization, isAuthorized, getTokenPayload } from '../../lib/auth';
import { handleError } from '../../lib/helpers/error-handler';

interface IAuthCallbackProps {
  location: Location;
  setUserIdClaimsName: (userIdClaimsName: string) => void;
  initializeApp: () => void;
}

const AuthCallback = ({ initializeApp, location, setUserIdClaimsName }: IAuthCallbackProps) => {
  const [isLoading, setLoadingLocal] = useState(true);

  useEffect(() => {
    if (!location) {
      setLoadingLocal(false);
      return;
    }

    const { code } = qs.parse(location.search, { ignoreQueryPrefix: true });
    fetchAccessTokenResponse(code)
      .then(() => fetchUserAuthorization())
      .catch(handleError)
      .finally(() => setLoadingLocal(false));
  }, [location]);

  if (isLoading) {
    return null;
  }

  if (isAuthorized()) {
    // Store initialization logic
    initializeApp();

    // Store auth data to redux state
    const tokenResponse = getTokenPayload();
    if (tokenResponse) {
      setUserIdClaimsName(tokenResponse.name ?? '');
    }
    // Added below code to redirect user to originally requested url post authentication, also removing the localstorage variable - INC3229025

    let userReqUrlStr = routes.dashboard;
    const userReqUrl = localStorage.getItem('user_requested_url');

    if (typeof userReqUrl === 'string') {
      userReqUrlStr = userReqUrl.toString();
    }

    localStorage.removeItem('user_requested_url');

    return <Redirect to={userReqUrlStr} />;
  }

  return <Redirect to={routes.unauthorized} />;
};

export default AuthCallback;
